import {FormModalProps} from "../../../utils/useFormModal";
import {Form, Input, Modal, Switch} from "antd";
import React from "react";
import {useWatch} from "antd/lib/form/Form";

function ModifyModal(props: FormModalProps) {
    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle />
                <Form.Item label={'商品编号'} rules={[{required: true}]}>
                    <Input value={`${form.getFieldValue('productCode')}（${form.getFieldValue('productName')}）`} disabled/>
                </Form.Item>
                <Form.Item name={'placeOrder'} label={'下单'} rules={[{required: true}]} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={'remark'} label={'备注'}>
                    <Input.TextArea rows={2}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
